// import React from "react";
// import { Select } from "antd";

// const LanguageOption = (props) => {
//   const storedLanguage = localStorage.getItem("selectedLanguage") || "en-US";
//   return (
//     <div className="lang-selector">
//     <Select
//       defaultValue='🇮🇳 Language'
//       value={storedLanguage}
//       onChange={props.onChange}
//       style={{ width: 150, marginTop: 0, color: "white !important"}}
//       size='small'
//       getPopupContainer={() => document.body}
//       dropdownStyle={{ zIndex: 100001 }}
//     >
//       <Select.Option value={"en-US"}>🇮🇳 English</Select.Option>
//       <Select.Option value={"hi"}>🇮🇳 हिंदी (Hindi)</Select.Option>
//       <Select.Option value={"marathi"}>🇮🇳 मराठी (Marathi)</Select.Option>
//       <Select.Option value={"telegu"}>🇮🇳 తెలుగు (Telegu)</Select.Option>
//     </Select>
//     </div>
//   );
// };

// export default LanguageOption;

import React, { useState } from "react";
import { Select } from "antd";

const LanguageOption = ({ onChange }) => {
  const [language, setLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "en-US"
  );

  const handleChange = (value) => {
    setLanguage(value);
    onChange?.(value);
  };

  return (
    <div className="lang-selector">
      <Select
        value={language}
        onChange={handleChange}
        style={{ width: 150 }}
        size="small"
        getPopupContainer={() => document.body}
        dropdownStyle={{ zIndex: 100001 }}
      >
        <Select.Option value="en-US">🇮🇳 English</Select.Option>
        <Select.Option value="hi">🇮🇳 हिंदी (Hindi)</Select.Option>
        <Select.Option value="mr">🇮🇳 मराठी (Marathi)</Select.Option>
        <Select.Option value="te">🇮🇳 తెలుగు (Telugu)</Select.Option>
      </Select>
    </div>
  );
};

export default LanguageOption;